import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Injectable } from '@angular/core';
import { AlertTwoTone } from '@ant-design/icons-angular/icons';
import { Observable } from 'rxjs/internal/Observable';
import { Alert } from 'selenium-webdriver';
import { map, catchError } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class QualityParameterService {

  o3ApiUrl: string = Constants.CORE_API_BASE_URL;
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) { }

  gettVariableGroupList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Quality_Parameter/parameterGroup', data);
  }

  sumbitGroup(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Quality_Parameter/AddParameterGroup', data);
  }
  updateGroup(data: any): Observable<any[]> {
    return this.http.put<any[]>(this.O3CoreApiUrl + 'Quality_Parameter/UpdateParameterGroup', data);
  }

  deleteGroupList(data: any): any {
    return this.http.post<any>(this.O3CoreApiUrl + 'Quality_Parameter/DeleteParameterGroup', data);
  }

  getVariableList(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'QualityParam/qualityparameter',
      data
    );
  }
  sumbitVariables(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'QualityParam/AddQualityParameter', data);
  }
  deleteParameter(data: any): any {
    return this.http.post<any>(this.O3CoreApiUrl + 'QualityParam/DeleteQualityParameter', data);
  }
  updateParameter(data: any): Observable<any[]> {
    return this.http.put<any[]>(
      this.O3CoreApiUrl + 'QualityParam/qualityparameter',
      data
    );
  }

  getParameterSpecificationsList(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.o3ApiUrl + 'QualityParam/GetQualityParameterSpec',
      data
    );
  }

  sumbitParameterSpecifications(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'QualityParam/AddQualityParameterSpec',
      data
    );
  }
  deleteParameterSpecifications(data: any): any {
    return this.http.post<any>(
      this.O3CoreApiUrl + 'QualityParam/DeleteParameterSpec',
      data
    );
  }
  updateParameterSpecifications(data: any): Observable<any[]> {
    return this.http.put<any[]>(this.O3CoreApiUrl + 'QualityParam/UpdateQualityParameterSpec', data);
  }
  getDataType(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.o3ApiUrl + 'Variable/GetDataType', data);
  }

  getDatasource(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.o3ApiUrl + 'Variable/GetDatasource',
      data
    );
  }

  getCalculationMethod(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.o3ApiUrl + 'Variable/GetCalculationMethod',
      data
    );
  }

  getInputTag(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.o3ApiUrl + 'Variable/GetCalculationMethod',
      data
    );
  }

  parameterList(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.o3ApiUrl + 'Variable/ParameterSpecification_Desc',
      data
    );
  }

  parameterLinkProduct(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.o3ApiUrl + 'Variable/ParameterSpecification_LinkProduct',
      data
    );
  }
  getGroupData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.o3ApiUrl + 'Common/GetGroup', data);
  }
  getMaxCavity(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'QualityParam/MaxCavity',
      data
    );
  }
  getQualityControlInterval(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'QualityParam/GetQualityControlInterval',
      data
    );
    //return this.http.post<any[]>(this.O3CoreApiUrl + 'QualityParam/GetQualityControlInterval',data);
  }
  getProcessControlInterval(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'QualityParam/GetProcessControlInterval',
      data
    );
  }
  getParameterSpecifications(data: any): Observable<any[]> {
    //return this.http.post<any[]>(this.baseUrl + 'parameterspecifications',data);
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'QualityParam/GetParameterSpecifications',
      data
    );
  }
  qualityparamaterdefects(data: any): Observable<any[]> {
    // return this.http.post<any[]>(this.baseUrl + 'qualityparamaterdefects',data);
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'QualityParam/GetParameterDefects',
      data
    );
  }
  saveQcVerify(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'Quality/SaveQcVerify',
      data
    );
  }
  GetQCVerifyDetail(data: any): Observable<any[]> {
    //return this.http.post<any[]>(this.baseUrl + 'getQCVerifyDetail', data);
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'QualityParam/GetQCVerifyDetail',
      data
    );
  }
  getQcVerify(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'QualityParam/GetQCVerify', data);
  }
  getQcVerify2(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'Quality/QCVerifyReport',
      data
    );
  }
  GetAllMasterEvents(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'QualityParam/GetAllMasterEvents',
      data
    );
  }

  // quality parameter routes

  GetAllQualityParameterIntervals(data: any): Observable<any[]> {
    // return this.http.post<any[]>(this.baseUrl + 'getallqualityparameterintervals', data
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'QualityParam/GetAllQualityParameterIntervals',
      data
    );
  }

  AddQualityParameterIntervals(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'QualityParam/AddQualityParameterInterval',
      data
    );
  }

  UpdateQualityParameterIntervals(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'QualityParam/UpdateQualityParameterInterval',
      data
    );
  }

  // data type routes

  async GetAllDataTypesDetail(data: any): Promise<any[]> {
    return await this.http
      .post<any[]>(
        this.O3CoreApiUrl + 'QualityParameter/GetAllDataTypeDetails',
        data
      )
      .toPromise();
  }

  AddDataType(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'QualityParameter/AddDataType',
      data
    );
  }

  UpdateDataType(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'QualityParameter/UpdateDataType',
      data
    );
  }

  DeleteDataType(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'QualityParameter/DeleteDataType',
      data
    );
  }
  getParamaterGroupType(): Observable<any[]> {
    return this.http.get<any[]>(
      this.O3CoreApiUrl + 'Variable/GetParameterGroupType'
    );
  }
  getQualityGroupbyUnit(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'QualityParam/getqualitygroupbyunit',
      data
    );
  }
  getVariableGroupbyUnit(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'QualityParameter/getvariablegroupbyunit',
      data
    );
  }
  // add datatype in quality
  AddVariableType(data: any): Observable<any[]> {
    // return this.http.post<any[]>(this.baseUrl + 'addvariableioevent', data);
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'VariableParameterGroup/AddVariableType',
      data
    );
  }

  GetAllDataTypeIds(data: any): Promise<any[]> {
    // return this.http
    //   .post<any[]>(this.baseUrl + 'getallparameterids', data)
    //   .toPromise();
    return this.http
      .post<any[]>(
        this.O3CoreApiUrl + 'VariableParameterGroup/GetAllDataTypeIds',
        data
      )
      .toPromise();
  }
  async getQualityGroupEvents(data: any): Promise<any[]> {
    return await this.http
      .post<any[]>(
        this.O3CoreApiUrl + 'QualityProcess/getQualityGroupEvents',
        data
      )
      .toPromise();
  }
  getCurrentProcessOrder(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'QualityParam/GetCurrentProcessOrder', data);
  }

  getBulkUploadExportExcel(data: any): Observable<Blob> {
    const fileUrl = this.O3CoreApiUrl + 'QPBulkUpload/DownloadExportExcelFile';
    return this.http.post(fileUrl, data, {
      responseType: 'arraybuffer'
    }).pipe(
      map((res: ArrayBuffer) => {
        return new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      }),
      catchError((error: any) => {
        throw error;
      })
    );
  }
  getBulkUploadExportExcelNew(data: any): Observable<Blob> {
    const fileUrl = this.O3CoreApiUrl + 'QPBulkUpload/DownloadExportExcelFileNew';
    return this.http.post(fileUrl, data, {
      responseType: 'arraybuffer'
    }).pipe(
      map((res: ArrayBuffer) => {
        return new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      }),
      catchError((error: any) => {
        throw error;
      })
    );
  }

  uploadQPMasterData(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    const fileUrl = this.O3CoreApiUrl + 'QPBulkUpload/UploadQPMasterData';
    return this.http.post(fileUrl, formData, {
      responseType: 'json'
    });
  }

  getBulkUploadSampleExcel(): Observable<Blob> {
    const fileUrl = this.O3CoreApiUrl + 'QPBulkUpload/DownloadExcelFile';
    return this.http.get(fileUrl, {
      responseType: 'arraybuffer'
    }).pipe(
      map((res: ArrayBuffer) => {
        return new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      }),
      catchError((error: any) => {
        throw error;
      })
    );
  }

  getBulkUploadSampleExcelNew(): Observable<Blob> {
    const fileUrl = this.O3CoreApiUrl + 'QPBulkUpload/DownloadExcelFileNew';
    return this.http.get(fileUrl, {
      responseType: 'arraybuffer'
    }).pipe(
      map((res: ArrayBuffer) => {
        return new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      }),
      catchError((error: any) => {
        throw error;
      })
    );
  }

  getCurrentProcessOrderDetails(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'SDFC/GetCurrentPoDetailByUnit', data);
  }
}
